import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  "data-name": "Group 5094",
  transform: "translate(5728.76 -8455)"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    "data-name": "Ellipse 1505",
    cx: "11",
    cy: "11",
    r: "11",
    transform: "translate(-5728.761 8455)",
    style: {"fill":"#3bb555"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "data-name": "Path 8424",
    d: "M12.011 5.031 11.48 4.5l-6.6 6.6-2.849-2.846-.531.531 3.378 3.378z",
    transform: "translate(-5724.516 8457.668)",
    style: {"fill":"#d7fad4","stroke":"#d7fad4","fill-rule":"evenodd"}
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };